import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: indent,
  },
  fullBase: {
    flex: 0,
    minHeight: '100%',
    paddingHorizontal: 0,
  },
  viewMoreOrderButton: {
    alignItems: 'center',
    paddingVertical: indent * 0.8,
  },
  loading: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: white,
    justifyContent: 'center',
  },
  scrollViewContainer: {
    flex: 1,
    width: '100%',
  },
});
